import { Star, Quote, ExternalLink } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export const Reviews = ({ reviews = [], property }) => {
  const { t } = useLang();
  if (!reviews.length) return null;
  return (
    <section id="reviews" className="py-20 md:py-28 bg-muted">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-10 flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <p className="text-primary font-medium text-sm uppercase tracking-widest mb-2">{t("Guest stories")}</p>
            <h2 className="font-script text-6xl md:text-8xl leading-tight text-foreground">
              {t("Loved by families")}
            </h2>
          </div>
          <div className="flex items-center gap-2">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="h-5 w-5 fill-amber-400 text-amber-400" />
              ))}
            </div>
            <span className="text-foreground font-semibold">4.95</span>
            <span className="text-muted-foreground">· 101 {t("reviews")}</span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((r, i) => (
            <div
              key={r.id || i}
              data-testid={`review-${i}`}
              className="bg-card rounded-2xl p-7 shadow-sm relative"
            >
              <Quote className="h-8 w-8 text-accent absolute top-6 right-6" />
              <div className="flex mb-4">
                {[...Array(r.rating || 5)].map((_, j) => (
                  <Star key={j} className="h-4 w-4 fill-amber-400 text-amber-400" />
                ))}
              </div>
              <p className="text-foreground leading-relaxed mb-6">"{t(r.text)}"</p>
              <div className="flex items-center gap-3">
                <div className="h-10 w-10 rounded-full bg-primary/15 flex items-center justify-center font-serif text-lg text-primary font-semibold">
                  {r.author?.[0]}
                </div>
                <div>
                  <div className="font-semibold text-foreground text-sm">{r.author}</div>
                  <div className="text-xs text-muted-foreground">{r.location}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {property?.airbnb_url && (
          <div className="mt-10 flex justify-center">
            <a
              href={property.airbnb_url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="see-all-reviews-btn"
              className="inline-flex items-center gap-2 rounded-full border border-foreground/20 bg-card px-7 py-3.5 text-foreground font-medium transition-all hover:-translate-y-0.5 hover:shadow-md hover:border-primary"
            >
              {t("Read all 101 reviews on Airbnb")}
              <ExternalLink className="h-4 w-4 text-primary" strokeWidth={1.75} />
            </a>
          </div>
        )}
      </div>
    </section>
  );
};
